import React from 'react';

import { AvailableIconName } from '@/assets/icons';
import { Stack } from '@/components/layout';
import { SvgIcon, Text } from '@/components/ui';
import { createStyles, useScaling } from '@/hooks';
import { colors, guardianColors } from '@/theme/colors';
import { fontFamilies } from '@/theme/typography';

type LevelDetailInfoCardProps = {
  iconSource: AvailableIconName;
  title: string;
  children: React.ReactNode;
};

export function LevelDetailInfoCard({ iconSource, title, children }: LevelDetailInfoCardProps) {
  const styles = useStyles();
  const { scale } = useScaling();

  return (
    <Stack style={styles.card} gap={scale(10)}>
      <Stack direction="row" align="center" gap={scale(4)}>
        <SvgIcon name={iconSource} width={scale(16)} height={scale(16)} />
        <Text
          fontFamily={fontFamilies.openSans}
          fontSize={scale(11)}
          lineHeight={scale(14.3)}
          fontWeight="600"
          style={styles.label}>
          {title}
        </Text>
      </Stack>
      {children}
    </Stack>
  );
}

export const useInfoCardStyles = createStyles(({ scale }) => ({
  bodyText: {
    color: guardianColors['10'],
  },
  criteriaRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: scale(4),
  },
  attemptsTitleRow: {
    paddingBottom: scale(8),
  },
}));

const useStyles = createStyles(({ scale }) => ({
  card: {
    width: '100%',
    paddingHorizontal: scale(16),
    paddingVertical: scale(12),
    borderRadius: scale(12),
    backgroundColor: colors['0'],
    overflow: 'hidden',
  },
  label: {
    color: guardianColors['6'],
    textTransform: 'uppercase',
  },
}));
